import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';

export default function LeaseCompSorting({ sort, onChange }) {
  return (
    <ManagedInput
      className="form-control"
      type="select"
      value={sort}
      onValueChange={onChange}
    >
      <option value="distance asc">Distance</option>
      <option value="updated_at desc">Last Modified (Desc)</option>
      <option value="updated_at asc">Last Modified (Asc)</option>
      <option value="created_at desc">Date Created (Desc)</option>
      <option value="created_at asc">Date Created (Asc)</option>
      <option value="lease_rate desc">Lease Rate (Desc)</option>
      <option value="lease_rate asc">Lease Rate (Asc)</option>
      <option value="size desc">Leased Space (Desc)</option>
      <option value="size asc">Leased Space (Asc)</option>
    </ManagedInput>
  );
}

LeaseCompSorting.propTypes = {
  sort: PropTypes.string,
  onChange: PropTypes.func,
};
